import { ResidentStatus } from '@lmc/ts-common'
import { Avatar, Heading } from '@lmc/ui-kit'
import InfoIcons from 'screens/Rostering/RotaBuilder/common/components/InfoIcons'
import { getNewAddress } from 'screens/Rostering/RotaPattern/utils'
import type { RotaResidentSummary } from 'screens/Rostering/types'
import { styled } from 'styled-components'

type ServiceUserInfoProps = {
  serviceUser: RotaResidentSummary
  avatarSize?: number
}

const ServiceUserInfo = ({ serviceUser, avatarSize }: ServiceUserInfoProps) => {
  if (!serviceUser) return null

  return (
    <SectionWrapper>
      <StyledAvatar size={avatarSize || 22} url={serviceUser.picture} />
      <Heading level={5} weight="medium">
        {`${serviceUser.name?.first} ${serviceUser.name?.last}`}
      </Heading>
      <InfoIcons
        address={
          serviceUser.addresses?.[0] && getNewAddress(serviceUser.addresses[0])
        }
        email={serviceUser.email}
        phone={serviceUser.phoneNumber}
        notes={serviceUser.carePackage?.visitNotes}
        visit
        inactive={serviceUser.status !== ResidentStatus.active}
        residentStatus={serviceUser.status}
      />
    </SectionWrapper>
  )
}

const StyledAvatar = styled(Avatar)`
  border: 0.5px solid ${(props) => props.theme.color.neutral.color7};
`

const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export default ServiceUserInfo
